/**
 * 项目默认配置文件
 */
//AJAX URL
export const FREE_REGISTER_SUBMIT_URL = 'https://cardloan.xiaoying.com/h5/user/simple_register';   //免密注册接口
export const REGISTER_SUBMIT_URL = 'https://cardloan.xiaoying.com/h5/user/register';   //卡贷H5注册页
export const REGISTER_SUBMIT_URL_ZT = 'https://zt.xiaoying.com/cardloan/baiyi_201712/register';   //百亿活动注册
export const CARDLOAN_CONFIG = 'https://cardloan.xiaoying.com/h5/homepage/get_channel_config';   //获取渠道号对应配置接口
//PAGE LINK
export const YYB_DOWNLOAD_LINK = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.xiaoying.cardloan';  //应用宝小赢卡贷APP下载页地址
export const KD_DOWNLOAD_LINK = 'https://cardloan.xiaoying.com/kadai/download';  //小赢卡贷APP下载页地址
export const NEW_DOWNLOAD_LINK = 'https://cardloan.xiaoying.com/fe/landing-page/download/index.html';  //小赢卡贷APP最新下载页地址

export const CARDLOAN_H5_LINK = 'https://cardloan.xiaoying.com/kadai/index.html';  //卡贷H5首页
export const CARDLOAN_H5_LOGIN_LINK = 'https://cardloan.xiaoying.com/kadai/index.html#!/login';  //卡贷H5登录页
export const CASHLOAN_H5_LINK = 'https://cardloan.xiaoying.com/cashloan/index';  //易贷H5首页
export const CASHLOAN_H5_LOGIN_LINK = 'https://cardloan.xiaoying.com/cashloan/index#!/login';  //易贷H5首页

export const ELITELOAN_H5_LINK = 'https://cardloan.xiaoying.com/fe/eliteloan-h5app/index.html';  //精英贷H5首页
export const ELITELOAN_H5_LOGIN_LINK = 'https://cardloan.xiaoying.com/fe/eliteloan-h5app/index.html#!/login';  //精英贷H5登录

export const TEMPLATE_REQUEST_LINK = '/h5/common/get_landing_page_data';  //模板请求接口

export const PAGE_LINK = {
  CARDLOAN_H5_LINK,
  CASHLOAN_H5_LINK,
  KD_DOWNLOAD_LINK,
  CARDLOAN_H5_LOGIN_LINK,
  CASHLOAN_H5_LOGIN_LINK,
  ELITELOAN_H5_LINK,
  ELITELOAN_H5_LOGIN_LINK
};
export const AJAX_URL = {
  REGISTER_SUBMIT_URL,
  CARDLOAN_CONFIG,
  FREE_REGISTER_SUBMIT_URL
};
export default {
  PAGE_LINK,
  AJAX_URL,
};



// WEBPACK FOOTER //
// ./src/common/cons.js